import apiClient from "../../apiClient";
import { CommonApiResponse } from "../../../Controllers/Types/ApiResponse";
import { baseURL } from "../../ApiConstant";

// get door list
export const getFSDoorList = async (fs_feature_id: number) => {
    try {
        const response = await apiClient.get(`/api/fs-door-list/${fs_feature_id}`);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        console.error("Error fetching data:", error);

        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};


// get door size list
export const getFSDoorSizeList = async () => {
    try {
        const response = await apiClient.get(`/api/fs-door-size-list`);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        console.error("Error fetching data:", error);

        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};